import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { XCircle } from "lucide-react";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";

export const PaymentCancelPage = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen bg-background text-foreground font-sans flex flex-col">
      <Navbar />
      <main className="flex-1 grid place-items-center px-6 py-24">
        <div className="max-w-md w-full rounded-3xl border border-white/10 bg-card p-10 text-center" data-testid="payment-cancel-page">
          <XCircle className="h-14 w-14 mx-auto text-slate-500" />
          <h1 className="mt-6 font-serif text-3xl text-white">{t("paymentPage.cancelTitle")}</h1>
          <p className="mt-3 text-sm text-slate-400">{t("paymentPage.cancelText")}</p>
          <div className="mt-8 flex flex-col gap-2">
            <Button asChild className="rounded-full brand-gradient text-white"><Link to="/packages">{t("paymentPage.backPackages")}</Link></Button>
            <Button asChild variant="outline" className="rounded-full border-white/20 text-slate-100 hover:bg-white/5"><Link to="/">{t("paymentPage.home")}</Link></Button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PaymentCancelPage;
